import { List, fromJS } from 'immutable';
import React from 'react';
import { Link } from 'react-router-dom';

// eslint-disable-next-line no-restricted-imports -- pre-existing DataTable2 usage; migrate off when touched
import DataTable from '@sophocles/components/DataTable2';

class TamperIssueList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: List(),
    };
  }

  render() {
    const { user, fetchTamperIssue } = this.props;
    const { data } = this.state;

    const columns = fromJS([
      {
        name: 'Customer ID',
        id: 'group_owner__site_group__customer__id',
        cellRenderer: (value, row) => row.getIn(['primary_site_group', 'customer', 'id']),
      },
      {
        name: 'Customer',
        id: 'group_owner__site_group__customer__name',
        cellRenderer: (value, row) => row.getIn(['primary_site_group', 'customer', 'name']),
      },
      {
        name: 'Plant',
        id: 'group_owner__site_group__name',
        cellRenderer: (value, row) => row.getIn(['primary_site_group', 'name']),
      },
      {
        name: 'Plant Desc',
        id: 'group_owner__site_group__description',
        cellRenderer: (value, row) => row.getIn(['primary_site_group', 'description']),
      },
      {
        name: 'Structure',
        id: 'name',
        cellRenderer: (value, row) => (
          <Link to={row.get('url')} target="_blank">
            {row.get('name')}
          </Link>
        ),
      },
      {
        name: 'ICCID',
        id: 'iccid',
        sortable: false,
      },
    ]);

    const searchFields = [
      'group_owner__site_group__customer__name',
      'relay_controller__radio__iccid',
      'name',
      'group_owner__site_group__customer__id',
      'group_owner__site_group__description',
      'group_owner__site_group__name',
    ];

    return (
      <DataTable
        columns={columns}
        fetchData={fetchTamperIssue}
        searchFields={searchFields}
        defaultSortBy="group_owner__site_group__customer__name"
        entryCountOptions={[10, 25, 50, -1]}
        defaultEntryCount={10}
      />
    );
  }
}

export default TamperIssueList;
